import { useEffect } from 'react';
import { useTriggerCondition } from '../../Emitter';
import { getBasicCondition } from '../../../helpers';
import { BASIC_TAG_LAUNCH_CONDITION } from '../../../constants';

export const useTriggerOnWrapperInit = () => {
    const triggerCondition = useTriggerCondition();

    useEffect(() => {
        triggerCondition(getBasicCondition({
            launch: BASIC_TAG_LAUNCH_CONDITION.onWrapperInit
        }));
    }, [triggerCondition]);
};
